module.exports = __webpack_public_path__ + "media/images/icons/new-icon-81a9a34861bef5d4ba5a54e74de95c9c.svg";